import { BaseViewStore } from 'core/stores';
import { action } from 'mobx';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { ModalParams } from "core/models";

class FacilityOrderTemplateNewFlowCustomOrderingDoctorAddViewStore extends BaseViewStore {
    constructor(rootStore, componentProps) {
        super(rootStore);

        this.rootStore = rootStore;
        this.facilityOrderTemplate = componentProps.facilityOrderTemplate;
        this.isClinicalInfoModal = componentProps.isClinicalInfoModal;
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);

        this.facilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal = new ModalParams({ onClose: async () => await this.facilityOrderTemplateService.updateCustomOrderingDoctor(this.facilityOrderTemplate) });
    }

    @action.bound
    async updateCustomOrderingDoctorData(action) {
        if (action === "change-doctor") {
            await this.openFacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal();
        }
        else if (action === "undo-change-doctor") {
            this.facilityOrderTemplate.customOrderingDoctorId = null;
            await this.facilityOrderTemplateService.updateCustomOrderingDoctor(this.facilityOrderTemplate);
        }
        else if (action === "remove-doctor") {
            this.facilityOrderTemplate.isOrderingDoctorRemoved = true;
            await this.facilityOrderTemplateService.updateCustomOrderingDoctor(this.facilityOrderTemplate);
        }
        else if (action === "undo-remove-doctor") {
            this.facilityOrderTemplate.isOrderingDoctorRemoved = false;
            await this.facilityOrderTemplateService.updateCustomOrderingDoctor(this.facilityOrderTemplate);
        }
    }

    @action.bound
    async openFacilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal() {
        await this.facilityOrderTemplateNewFlowCustomOrderingDoctorChangeModal.open({
            facilityOrderTemplate: this.facilityOrderTemplate
        });
    }
}

export default FacilityOrderTemplateNewFlowCustomOrderingDoctorAddViewStore;
